/** @format */

import { i18nContext } from '@/context/i18nContext';
import { FunctionComponent as FC, useEffect } from 'react';
import ReactDOM from 'react-dom';
import CloseIcon from '../../assets/icons/icon_close_modal.svg';
import { useLockScroll } from '../../hooks/useLockScroll';
import { Icon } from '../ui/Icon';
import { Content, IconButton, Overlay, Wrapper } from './Modal.style';

export const Modal: FC<Props> = ({ isOpen, onClose, children }) => {
  const { lockScroll, unlockScroll } = useLockScroll();

  useEffect(() => {
    const closeOnEscapeKey = (e: KeyboardEvent) => (e.key === 'Escape' ? onClose() : null);
    document.body.addEventListener('keydown', closeOnEscapeKey);
    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKey);
    };
  }, [onClose]);

  useEffect(() => {
    isOpen ? lockScroll() : unlockScroll();
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <Wrapper>
      <i18nContext.Consumer>
        {t => (
          <>
            <Overlay onClick={onClose} />
            <Content>
              <IconButton
                onClick={onClose}
                title={t['aria-label']['closeModal']}
                aria-label={t['aria-label']['closeModal']}
              >
                <Icon icon={CloseIcon} width={32} height={32} />
              </IconButton>
              {children}
            </Content>
          </>
        )}
      </i18nContext.Consumer>
    </Wrapper>,
    document.body,
  );
};

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};
